export const PermissionDeniedReason = "PERMISSION_DENIED";
export const PlanRequiredReason = "PLAN_REQUIRED";
export const ImpersonationRevokedReason = "IMPERSONATION_REVOKED";

type CallableErrorDetails = {
  reason?: string;
  permission?: string;
  role?: string;
  plans?: string[];
};

export type CallableErrorLike = {
  code?: string;
  message?: string;
  details?: CallableErrorDetails;
};

const DefaultMessage = "Something went wrong. Please try again.";

/** User-facing text from a Firebase httpsCallable rejection (backend sets `message`). */
export function getCallableErrorMessage(
  error: unknown,
  fallback: string = DefaultMessage
): string {
  if (!error || typeof error !== "object") return fallback;
  const message = (error as CallableErrorLike).message;
  if (typeof message === "string" && message.trim()) return message.trim();
  return fallback;
}

export function getCallableErrorDetails(
  error: unknown
): CallableErrorDetails | undefined {
  if (!error || typeof error !== "object") return undefined;
  return (error as CallableErrorLike).details;
}

export function isCallablePermissionDenied(error: unknown): boolean {
  return (
    getCallableErrorDetails(error)?.reason === PermissionDeniedReason
  );
}

export function isCallablePlanRequired(error: unknown): boolean {
  return getCallableErrorDetails(error)?.reason === PlanRequiredReason;
}
